import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForTaxes = () => {
  return {
    taxes: [],
    data:{}
  }
}


// state
const state = getDefaultStateForTaxes()
// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_TAXES (state) {
        Object.assign(state, getDefaultStateForTaxes())
    },
    FETCH_ALL(state, data){
        state.taxes = data
    },
    FETCH(state, data) {
      state.data = data
    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_TAXES")
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['TAX_CODES_LIST'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['GET_TAX_RATE'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } 
            else 
            {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
}

export {
    state,
    getters,
    actions,
    mutations
}
